import MedicationAnswer from "../abstract/MedicationAnswer"
import BoolQuestionAnswerStrategy from "../abstract/BoolQuestionAnswerStrategy"
import MedicationQuestion from "../abstract/MedicationQuestion"
import QuestionCreator from "../abstract/QuestionCreator"

const PatientSymptomsImproved =
    (
        answer: MedicationAnswer,
        optional: {
            strategy: BoolQuestionAnswerStrategy
            alternativeAnswer?: MedicationAnswer
        } = { strategy: BoolQuestionAnswerStrategy.ON_YES }
    ): QuestionCreator =>
        (input) =>
            new MedicationQuestion(
                "Gibt es Anzeichen für eine klinisch relevante Verbesserung der Symptomatik?",
                input
            ).answerAutomatically((input) => {
                if (input.symptomImprovement) {
                    return optional.strategy === BoolQuestionAnswerStrategy.ON_YES
                        ? answer
                        : optional.alternativeAnswer
                            ? optional.alternativeAnswer
                            : new MedicationAnswer("Ja")
                }
                return optional.strategy === BoolQuestionAnswerStrategy.ON_NO
                    ? answer
                    : optional.alternativeAnswer
                        ? optional.alternativeAnswer
                        : new MedicationAnswer("Nein")
            })

export default PatientSymptomsImproved
